const userAgent = navigator.userAgent;
// 校验浏览器标识是PC、还是手机
const inMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(userAgent);
const inPC = !inMobile;
// 校验是否是iOS系统
const inIos = /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
// 校验是否是Android系统
const inAndroid = /(Android)/i.test(userAgent);
// 校验是否在大救星APP中
let inDjxApp = false;
if (inIos && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getStatusBarHeight) {
  inDjxApp = true;
} else if (inAndroid && window.JSInterface && window.JSInterface.getStatusBarHeight) {
  inDjxApp = true;
}
// 校验是否是微信浏览器
const inWxBrowser = /micromessenger/i.test(userAgent.toLowerCase());

export default {
  inMobile,
  inPC,
  inIos,
  inAndroid,
  inDjxApp,
  inWxBrowser
}



// WEBPACK FOOTER //
// ./src/assets/js/env.js